import { env } from "@/config/env";

export const REFERRAL_CREDIT_AMOUNT =
  env.VITE_DISCOUNT_PER_REFERRAL_CENTS / 100;

export const REFERRAL_MIN_CREDIT_TO_USE =
  env.VITE_REFERRAL_MIN_CREDITS_CENTS / 100;

export const MONTHLY_CAP_CREDIT = env.VITE_REFERRAL_MAX_CREDITS_CENTS / 100;
